import { CommonModule } from '@angular/common';
import { afterNextRender, Component, ElementRef, forwardRef, input, model, output, viewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-input-password',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './input-password.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputPassword),
            multi: true,
        },
    ],
})
export class InputPassword implements ControlValueAccessor {
    inputElement = viewChild<ElementRef>('input');

    formControlName = input<string>('password');
    class = input<string>('');
    maxLength = input<number>(100);
    placeholder = input<string>('비밀번호를 입력해 주세요.');

    invalidOutput = output<boolean>();

    value = model<string>('');

    constructor() {
        afterNextRender(() => {
            if (this.inputElement()) this.inputElement()!.nativeElement.value = this.value();
        });
    }

    writeValue(obj: any): void {
        this.value.set(obj);
    }
    onChange: (value: string) => void = () => {};
    registerOnChange(fn: any): void {}
    registerOnTouched(fn: any): void {}
    setDisabledState?(isDisabled: boolean): void {}

    onInput(event: Event): void {
        const inputElement = event.target as HTMLInputElement;

        const regExp1 = /^.{8,}$/;
        const regExp2 = /(?=.*[a-z])(?=.*\d)/;
        const regExp3 = /(?=.*[\W_])/;

        const isValid = regExp1.test(inputElement.value) && regExp2.test(inputElement.value) && regExp3.test(inputElement.value);
        this.invalidOutput.emit(!isValid);

        this.value.set(inputElement.value);
        this.onChange(inputElement.value);
    }
}
